import { useColorModeValue } from "@chakra-ui/react";
import useTable from "hooks/use-table";
import { FC, useMemo } from "react";

import TableGridItem from "./Item";
import TableGridItemScheduleSupplierDrawer from "./Purchase/itemSchedule";
import TableGridItemPurchaseSkus from "./Purchase/ItemSku";
import TableGridItemPurchaseSkusResume from "./Purchase/ItemSkuResume";
import TableGridItemPurchaseSupplier from "./Purchase/ItemSupplier";
import TableGridItemScheduleDrawer from "./Schedule.tsx/ItemSchedule";

interface ITableGridBody {
  undoValue?: number;
  updateIsGraphic?: (data: any) => void;
  updatedFinalStorage?: (value: string, data: any) => void;
}

const TableGridBody: FC<ITableGridBody> = ({
  undoValue,
  updateIsGraphic,
  updatedFinalStorage,
}) => {
  const { data: rows, columns, actions, entity } = useTable();

  const columnsCount = useMemo(() => {
    let count = 0;

    for (const column of columns) {
      if (column.columns) {
        count += column.columns?.length;
      } else {
        count += 1;
      }
    }
    if (actions && actions.length > 0) {
      count++;
    }
    return count;
  }, [columns, actions]);

  return (
    <tbody color="black">
      {rows.data.length === 0 ? (
        <tr>
          <td colSpan={columnsCount + 1} align="center">
            Dados não encontrados
          </td>
        </tr>
      ) : (
        rows.data.map((row: any, key: number) => (
          <>
            {(() => {
              if (entity === "schedule-drawer") {
                return (
                  <TableGridItemScheduleDrawer
                    data={row}
                    key={`table-grid-${key + 1}`}
                  />
                );
              } else if (entity === "schedule-supplier-drawer") {
                return (
                  <TableGridItemScheduleSupplierDrawer
                    data={row}
                    key={`table-grid-${key + 1}`}
                  />
                );
              } else if (entity === "purchase-supplier") {
                return (
                  <TableGridItemPurchaseSupplier
                    data={row}
                    key={`table-grid-${key + 1}`}
                  />
                );
              } else if (entity === "purchase-supplier-skus") {
                return (
                  <TableGridItemPurchaseSkus
                    data={row}
                    key={`table-grid-${key + 1}`}
                  />
                );
              } else if (entity === "purchase-supplier-skus-resume") {
                return (
                  <TableGridItemPurchaseSkusResume
                    data={row}
                    key={`table-grid-${key + 1}`}
                  />
                );
              } else {
                return (
                  <TableGridItem data={row} key={`table-grid-${key + 1}`} />
                );
              }
            })()}
          </>
        ))
      )}
    </tbody>
  );
};

export default TableGridBody;
